module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#rss",
      toString: function () {
        return this.url;
      }
    }